import { Flex, Icon, Text, Tooltip, Spinner } from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';
import { useCreateSessionMutation } from '@/store/query/agentforge/chat';
import { useGetAgentsQuery } from '@/store/query/agentforge/mission-control';

type NewTaskButtonProps = {
  isCollapsed: boolean;
};

const PlusIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9 3.75V14.25M3.75 9H14.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const NewTaskButton = ({ isCollapsed }: NewTaskButtonProps) => {
  const history = useHistory();
  const [createSession, { isLoading }] = useCreateSessionMutation();
  const { data: agents = [] } = useGetAgentsQuery();

  const handleNewTask = async () => {
    if (isLoading) return;
    const pipelineManager = agents.find((a) => a.slug === 'pipeline-manager');
    if (!pipelineManager) {
      history.push('/forge/chat');
      return;
    }
    try {
      const session = await createSession({
        agent_id: pipelineManager.id,
        title: 'New Chat',
      }).unwrap();
      if (session?.id) {
        history.push(`/forge/chat?session=${session.id}`);
      } else {
        history.push('/forge/chat');
      }
    } catch {
      history.push('/forge/chat');
    }
  };

  return (
    <Tooltip
      isDisabled={!isCollapsed}
      label="New task"
      arrowSize={8}
      hasArrow
      placement="right"
      borderRadius="4px"
      variant="default"
    >
      <Flex
        alignItems="center"
        cursor="pointer"
        p="8px 12px"
        borderRadius="6px"
        mb="2px"
        minH="42px"
        border="1px dashed"
        borderColor="secondary-200"
        _hover={{ bg: 'primary-50', borderColor: 'primary-300' }}
        transition="all 0.15s ease"
        onClick={handleNewTask}
      >
        {isLoading ? (
          <Spinner size="xs" color="primary-500" mr="10px" />
        ) : (
          <Icon
            as={PlusIcon}
            width="18px"
            height="18px"
            color="primary-500"
            mr="10px"
          />
        )}
        {!isCollapsed && (
          <Text
            fontSize="14px"
            fontWeight={500}
            color="primary-500"
            whiteSpace="nowrap"
          >
            New task
          </Text>
        )}
      </Flex>
    </Tooltip>
  );
};
